import React from "react";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";

/**
 * ExportToExcelButton
 * Props:
 * - rows: array of row objects
 * - columns: array of column defs (expects { field, headerName, hide? })
 * - filename: string (default: members.xlsx)
 * - label: string (default: Export)
 * - getRows: optional async function returning rows
 * - disabled: optional boolean to disable the button
 */
const ExportToExcelButton = ({
  rows = [],
  columns = [],
  filename = "members.xlsx",
  label = "Export",
  getRows,
  disabled = false,
}) => {
  const handleExport = async () => {
    const exportRows = getRows ? await getRows() : rows;
    if (!exportRows || exportRows.length === 0) return;

    const visibleCols = (columns || []).filter((c) => c?.field && c?.headerName && c?.hide !== true);
    const headerRow = visibleCols.map((c) => c.headerName);

    const dataRows = exportRows.map((r) =>
      visibleCols.map((c) => {
        const v = r?.[c.field];
        if (v === null || v === undefined) return "";
        // Basic formatting for objects/arrays
        if (typeof v === "object") return JSON.stringify(v);
        return v;
      })
    );

    const ws = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Members");
    XLSX.writeFile(wb, filename);
  };

  return (
    <Button variant="outlined" startIcon={<DownloadIcon />} onClick={handleExport} disabled={disabled}>
      {label}
    </Button>
  );
};

export default ExportToExcelButton;
